import ltCyodPopup from 'html/packages/lt-cyod-popup.html';
import App from 'app/app.js';
import 'app/directive/LtCyodPopupCtrl.js';

function LtCyodPopupDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onCancellation: '&',
      packageList: '=',
      selectClick: '&'
    },
    template: ltCyodPopup,
    controller: 'LtCyodPopupCtrl',
    controllerAs: 'cyodPopup'
  };
}

App.directive('ltCyodPopup', [LtCyodPopupDirective]);
